var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailedT({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#FCDFDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 5.29622C8.23391 5.29622 8.46641 5.44372 8.6435 5.73872L11.1068 9.84456C11.4614 10.4341 11.1877 10.9166 10.5002 10.9166H5.50016C4.81266 10.9166 4.53891 10.4337 4.8935 9.84456L7.35683 5.73872C7.53391 5.44372 7.76641 5.29622 8.00016 5.29622ZM8.00016 4.46289C7.46016 4.46289 6.966 4.77122 6.64225 5.30914L4.17891 9.41581C3.85141 9.96122 3.81558 10.5429 4.081 11.0116C4.34641 11.4804 4.86391 11.75 5.50016 11.75H10.5002C11.1364 11.75 11.6543 11.4808 11.9193 11.0121C12.1843 10.5433 12.1489 9.96164 11.8214 9.41622L9.35808 5.31039C9.03433 4.77122 8.54016 4.46289 8.00016 4.46289Z",
    fill: "#F15D5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 10.2083C8.29932 10.2083 8.54183 9.96582 8.54183 9.66667C8.54183 9.36751 8.29932 9.125 8.00016 9.125C7.70101 9.125 7.4585 9.36751 7.4585 9.66667C7.4585 9.96582 7.70101 10.2083 8.00016 10.2083Z",
    fill: "#F15D5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62497 7.16675C8.62497 6.82091 8.34538 6.54175 7.99997 6.54175C7.89767 6.54177 7.79694 6.56691 7.70663 6.61497C7.61633 6.66303 7.53921 6.73254 7.48205 6.81739C7.4249 6.90223 7.38946 6.99981 7.37886 7.10156C7.36825 7.20331 7.38279 7.30611 7.42122 7.40091C7.65205 7.97425 7.99997 8.83341 7.99997 8.83341L8.57955 7.40091C8.60788 7.32883 8.62497 7.24966 8.62497 7.16675Z",
    fill: "#F15D5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedT);
export default __webpack_public_path__ + "static/media/failed-t.de6446a7b57b5ea052be059d1e394c68.svg";
export { ForwardRef as ReactComponent };